import { render, staticRenderFns } from "./ConfigBasicInfo.vue?vue&type=template&id=0311ec86&scoped=true"
import script from "./ConfigBasicInfo.vue?vue&type=script&lang=ts"
export * from "./ConfigBasicInfo.vue?vue&type=script&lang=ts"
import style0 from "./ConfigBasicInfo.vue?vue&type=style&index=0&id=0311ec86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311ec86",
  null
  
)

export default component.exports